"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleJsonUtils = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_product_models_1 = require("@igus/echain-product-models");
/**
 * The `ArticleJsonUtils` provides functions operating on primitive quote json objects.
 */
class ArticleJsonUtils {
    static areSameArticles(a1, a2) {
        if (a1.ArticleType && a1.ArticleType !== a2.ArticleType) {
            return false;
        }
        if (a1.EntityId && a2.EntityId) {
            return a1.EntityId === a2.EntityId;
        }
        if (a1.EchainId && a2.EchainId) {
            return a1.EchainId === a2.EchainId;
        }
        if (a1.Id != null && a2.Id != null) {
            return a1.Id === a2.Id;
        }
        if (a1.ArtNrGenerated && a2.ArtNrGenerated) {
            return a1.ArtNrGenerated === a2.ArtNrGenerated;
        }
        if (a1.ArtNr && a2.ArtNr) {
            return Object.values(a1.ArtNr).some((a1ArtNr) => a2.ArtNr && Object.values(a2.ArtNr).some((a2ArtNr) => a1ArtNr === a2ArtNr));
        }
        return false;
    }
    /**
     * Performs an Object.assign on each oldJson found in newJsons matched by given isEqual function.
     * If no isEqual function argument is given, 'Id' is used to compare articles.
     */
    static assignJsons(oldJsons = [], newJsons = [], isEqual // eslint-disable-line
    ) {
        oldJsons.forEach((oldJson) => ArticleJsonUtils.assignJson(oldJson, newJsons, isEqual));
    }
    /**
     * Performs an Object.assign on oldJson found in newJsons matched by given isEqual function.
     * If no isEqual function argument is given, 'Id' is used to compare articles.
     */
    static assignJson(oldJson, newJsons = [], isEqual = (ArticleJsonUtils.areSameArticles)) {
        if (oldJson == null)
            return;
        const newJson = newJsons.find((njson) => {
            return isEqual(oldJson, njson);
        });
        if (!newJson)
            return;
        const oldJsonArticleType = oldJson.ArticleType;
        switch (oldJsonArticleType) {
            case echain_product_models_1.ArticleType.zugentlastung: {
                const zugentlastungJson = oldJson;
                const oldBreite = zugentlastungJson.Breite;
                Object.assign(oldJson, newJson);
                // 'Laengeneingabe' => article's with XXX in the artNumber,
                // .. we need to restore the "old" Breite.
                if (zugentlastungJson.Laengeneingabe) {
                    zugentlastungJson.Breite = oldBreite;
                }
                return;
            }
            case echain_product_models_1.ArticleType.leitung:
            case echain_product_models_1.ArticleType.link:
            case echain_product_models_1.ArticleType.kette:
            case echain_product_models_1.ArticleType.ae:
            case echain_product_models_1.ArticleType.ia:
            case echain_product_models_1.ArticleType.verpackung:
            case echain_product_models_1.ArticleType.konfektionierung:
            case echain_product_models_1.ArticleType.fuehrungsrinne:
            case echain_product_models_1.ArticleType.montageSet:
            case echain_product_models_1.ArticleType.montBes:
            case echain_product_models_1.ArticleType.espool:
            case echain_product_models_1.ArticleType.zubehoer:
            case undefined:
                Object.assign(oldJson, newJson);
                return;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(oldJsonArticleType);
        }
    }
    /**
     * Returns an empty article json with only the ArtNr+ArtNrGenerated fields set
     */
    static onlyArtNr(artNr, countryCode = 'DE') {
        return {
            ArtNr: {
                [countryCode]: artNr,
            },
            ArtNrGenerated: artNr,
        };
    }
}
exports.ArticleJsonUtils = ArticleJsonUtils;
//# sourceMappingURL=ArticleJsonUtils.js.map